<div class="d-flex justify-content-center align-items-center w-100 h-100 error-container">
  <div class="col-xl-4 col-md-6 col-10">
    <div class="card border-0 box-shadow rounded-0">
      <div class="card-header d-flex justify-content-center align-items-center border-0 box-shadow">
        <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
      </div>
      <div class="card-body text-center">

        <h1 class="display-1">404</h1>
        <h6 class="card-title">Oops, it seems that this page does not exist.</h6>

        <button class="btn btn-lg" type="button" (click)="ok()" [disabled]="isLoading" data-testid="not-found-ok">
          {{ !isLoading ? 'OK' : 'Please Wait...' }}
        </button>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/core/components/errors/not-found/not-found.component.html